module.exports = __webpack_public_path__ + "img/f8.935bb678.jpg";